function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "pass-filled",
  d: "M12.9,20.566a8,8,0,1,0-8-8A8.052,8.052,0,0,0,12.9,20.566ZM10.265,15.94A.731.731,0,0,1,9.53,15.2a.7.7,0,0,1,.224-.511l2.1-2.112-2.1-2.1a.705.705,0,0,1-.224-.511.725.725,0,0,1,.735-.735.705.705,0,0,1,.526.209l2.112,2.1,2.12-2.112a.719.719,0,0,1,.526-.217.728.728,0,0,1,.511,1.253l-2.1,2.112,2.1,2.1a.746.746,0,0,1,.217.518.733.733,0,0,1-.743.743A.755.755,0,0,1,15,15.723l-2.1-2.1-2.1,2.1A.717.717,0,0,1,10.265,15.94Z",
  transform: "translate(-4.903 -4.566)"
});

function SvgPassedFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.008 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassedFill);
export default __webpack_public_path__ + "static/media/passed_fill.9a26654c.svg";
export { ForwardRef as ReactComponent };